import { ScopeSet } from 'root/src/shared/@types/auth';
import { providerToPlatform } from 'root/src/shared/util/platformHelpers';
export const getDesiredScopeCookieKey = (provider) => {
    const platform = providerToPlatform(provider);
    return `desiredScope.${platform}`;
};
export const isScopeSet = (value) => {
    if (!value) {
        return false;
    }
    return Object.values(ScopeSet).includes(Number(value));
};
